<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/login">Login</router-link>
  </nav> -->
  <img class="logo" alt="FireAds logo" src="./assets/logo.svg" />
  <router-view />
</template>
